/**
 * 总览-路由
 * Create by liaokai on 2020-04-17 10:16:40
 */
import * as React from 'react';
import {Component} from "react";
import {SurfaceRouter, tSurfaceRouteItem} from "../../../../../../components/surface-router/surface-router";
import {RouteComponentProps} from "react-router";
import {MeetingOverview} from "./overview";

interface IProps extends RouteComponentProps{

}

interface IState{

}

const routerData : tSurfaceRouteItem = {
    breadTitle : "总览",
    routeName : "",
    component : MeetingOverview,
    children : []
}

export class OverviewRouter extends Component<IProps,IState>{
    readonly state : IState = {

    };
    render() {
        let {} = this.props;
        let {} = this.state;
        return (
            <SurfaceRouter {...this.props} entryRoute={routerData}/>
        );
    }
}
